// removed by extract-text-webpack-plugin
module.exports = {"height":"style--height--9e3eae","shake":"style--shake--1eb3b5","bounceIn":"style--bounceIn--a5fd64","bounceOut":"style--bounceOut--e9a771"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Main/style.scss
// module id = WTvP
// module chunks = 7